
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, int32_type, list_type, bool_type, record_type, option_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ProcedureTemplateHookTriggerType_$reflection } from "./Procedure.js";

export class ProcedureTemplateExportEmailRecipient extends Record {
    constructor(Kind, Address, UserName, UserEmail) {
        super();
        this.Kind = Kind;
        this.Address = Address;
        this.UserName = UserName;
        this.UserEmail = UserEmail;
    }
}

export function ProcedureTemplateExportEmailRecipient_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateExportEmailRecipient", [], ProcedureTemplateExportEmailRecipient, () => [["Kind", string_type], ["Address", option_type(string_type)], ["UserName", option_type(string_type)], ["UserEmail", option_type(string_type)]]);
}

export class ProcedureTemplateExportElement extends Record {
    constructor(Label, Type, Required, Options, InspectionTemplateName, PropertyConfigurationName, MinCount, MaxCount, AttachProtocolPdf, EmailRecipients, EmailSubject, EmailBody, AllowRecipientEditing) {
        super();
        this.Label = Label;
        this.Type = Type;
        this.Required = Required;
        this.Options = Options;
        this.InspectionTemplateName = InspectionTemplateName;
        this.PropertyConfigurationName = PropertyConfigurationName;
        this.MinCount = MinCount;
        this.MaxCount = MaxCount;
        this.AttachProtocolPdf = AttachProtocolPdf;
        this.EmailRecipients = EmailRecipients;
        this.EmailSubject = EmailSubject;
        this.EmailBody = EmailBody;
        this.AllowRecipientEditing = AllowRecipientEditing;
    }
}

export function ProcedureTemplateExportElement_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateExportElement", [], ProcedureTemplateExportElement, () => [["Label", string_type], ["Type", string_type], ["Required", bool_type], ["Options", list_type(string_type)], ["InspectionTemplateName", option_type(string_type)], ["PropertyConfigurationName", option_type(string_type)], ["MinCount", option_type(int32_type)], ["MaxCount", option_type(int32_type)], ["AttachProtocolPdf", bool_type], ["EmailRecipients", option_type(list_type(ProcedureTemplateExportEmailRecipient_$reflection()))], ["EmailSubject", option_type(string_type)], ["EmailBody", option_type(string_type)], ["AllowRecipientEditing", option_type(bool_type)]]);
}

export class ProcedureTemplateExportStep extends Record {
    constructor(Name, Description, Elements) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.Elements = Elements;
    }
}

export function ProcedureTemplateExportStep_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateExportStep", [], ProcedureTemplateExportStep, () => [["Name", string_type], ["Description", string_type], ["Elements", list_type(ProcedureTemplateExportElement_$reflection())]]);
}

export class ProcedureTemplateExportInformationField extends Record {
    constructor(Type, PropertyConfigurationName) {
        super();
        this.Type = Type;
        this.PropertyConfigurationName = PropertyConfigurationName;
    }
}

export function ProcedureTemplateExportInformationField_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateExportInformationField", [], ProcedureTemplateExportInformationField, () => [["Type", string_type], ["PropertyConfigurationName", option_type(string_type)]]);
}

export class ProcedureTemplateExportHook extends Record {
    constructor(TriggerType, IsMandatory, CategoryNames, TargetStateKey, TargetStateName, RoleNames) {
        super();
        this.TriggerType = TriggerType;
        this.IsMandatory = IsMandatory;
        this.CategoryNames = CategoryNames;
        this.TargetStateKey = TargetStateKey;
        this.TargetStateName = TargetStateName;
        this.RoleNames = RoleNames;
    }
}

export function ProcedureTemplateExportHook_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateExportHook", [], ProcedureTemplateExportHook, () => [["TriggerType", string_type], ["IsMandatory", bool_type], ["CategoryNames", list_type(string_type)], ["TargetStateKey", option_type(string_type)], ["TargetStateName", option_type(string_type)], ["RoleNames", list_type(string_type)]]);
}

export class ProcedureTemplateExport extends Record {
    constructor(FormatVersion, Name, Description, InformationFields, Steps, Hooks) {
        super();
        this.FormatVersion = (FormatVersion | 0);
        this.Name = Name;
        this.Description = Description;
        this.InformationFields = InformationFields;
        this.Steps = Steps;
        this.Hooks = Hooks;
    }
}

export function ProcedureTemplateExport_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateExport", [], ProcedureTemplateExport, () => [["FormatVersion", int32_type], ["Name", string_type], ["Description", string_type], ["InformationFields", list_type(ProcedureTemplateExportInformationField_$reflection())], ["Steps", list_type(ProcedureTemplateExportStep_$reflection())], ["Hooks", list_type(ProcedureTemplateExportHook_$reflection())]]);
}

export const currentFormatVersion = 1;

export class ProcedureTemplateExportFileDto extends Record {
    constructor(FileName, Content) {
        super();
        this.FileName = FileName;
        this.Content = Content;
    }
}

export function ProcedureTemplateExportFileDto_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateExportFileDto", [], ProcedureTemplateExportFileDto, () => [["FileName", string_type], ["Content", string_type]]);
}

export class ProcedureTemplateImportRequestDto extends Record {
    constructor(Content) {
        super();
        this.Content = Content;
    }
}

export function ProcedureTemplateImportRequestDto_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateImportRequestDto", [], ProcedureTemplateImportRequestDto, () => [["Content", string_type]]);
}

export class ProcedureTemplateImportHintKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InspectionTemplateMissing", "PropertyConfigurationMissing", "InformationFieldSkipped", "ImageMissing", "CategoryMissing", "RoleMissing", "TargetStateMissing", "EmailUserMissing"];
    }
}

export function ProcedureTemplateImportHintKind_$reflection() {
    return union_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateImportHintKind", [], ProcedureTemplateImportHintKind, () => [[], [], [], [], [], [], [], []]);
}

export class ProcedureTemplateImportHintDto extends Record {
    constructor(Kind, Name, ElementLabel, TriggerType) {
        super();
        this.Kind = Kind;
        this.Name = Name;
        this.ElementLabel = ElementLabel;
        this.TriggerType = TriggerType;
    }
}

export function ProcedureTemplateImportHintDto_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateImportHintDto", [], ProcedureTemplateImportHintDto, () => [["Kind", ProcedureTemplateImportHintKind_$reflection()], ["Name", string_type], ["ElementLabel", option_type(string_type)], ["TriggerType", option_type(ProcedureTemplateHookTriggerType_$reflection())]]);
}

export class ProcedureTemplateImportResultDto extends Record {
    constructor(ProcedureTemplateId, Name, Hints) {
        super();
        this.ProcedureTemplateId = ProcedureTemplateId;
        this.Name = Name;
        this.Hints = Hints;
    }
}

export function ProcedureTemplateImportResultDto_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.ProcedureTemplateImportResultDto", [], ProcedureTemplateImportResultDto, () => [["ProcedureTemplateId", string_type], ["Name", string_type], ["Hints", list_type(ProcedureTemplateImportHintDto_$reflection())]]);
}

export class PredefinedProcedureTemplateDto extends Record {
    constructor(Key, Name, Description, InspectionTemplateNames, AlreadyExists) {
        super();
        this.Key = Key;
        this.Name = Name;
        this.Description = Description;
        this.InspectionTemplateNames = InspectionTemplateNames;
        this.AlreadyExists = AlreadyExists;
    }
}

export function PredefinedProcedureTemplateDto_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.PredefinedProcedureTemplateDto", [], PredefinedProcedureTemplateDto, () => [["Key", string_type], ["Name", string_type], ["Description", string_type], ["InspectionTemplateNames", list_type(string_type)], ["AlreadyExists", bool_type]]);
}

export class LoadPredefinedProcedureTemplatesRequestDto extends Record {
    constructor(Keys) {
        super();
        this.Keys = Keys;
    }
}

export function LoadPredefinedProcedureTemplatesRequestDto_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.LoadPredefinedProcedureTemplatesRequestDto", [], LoadPredefinedProcedureTemplatesRequestDto, () => [["Keys", list_type(string_type)]]);
}

export class LoadPredefinedProcedureTemplatesResultDto extends Record {
    constructor(Created, CreatedInspectionTemplateNames) {
        super();
        this.Created = Created;
        this.CreatedInspectionTemplateNames = CreatedInspectionTemplateNames;
    }
}

export function LoadPredefinedProcedureTemplatesResultDto_$reflection() {
    return record_type("Shared.ProcedureTemplateTransfer.LoadPredefinedProcedureTemplatesResultDto", [], LoadPredefinedProcedureTemplatesResultDto, () => [["Created", list_type(ProcedureTemplateImportResultDto_$reflection())], ["CreatedInspectionTemplateNames", list_type(string_type)]]);
}

